import React from 'react'

interface HomeScreenCardProps {
  gridColumn?: string
  gridRow?: string
  bgStyle?: React.CSSProperties
  overlayImage?: string
  overlayImageStyle?: React.CSSProperties
  onClick?: () => void
  style?: React.CSSProperties
  children?: React.ReactNode
  statusBar?: React.ReactNode
}

const HomeScreenCard: React.FC<HomeScreenCardProps> = ({
  gridColumn,
  gridRow,
  bgStyle,
  overlayImage,
  overlayImageStyle,
  onClick,
  style,
  children,
  statusBar,
}) => (
  <div
    className={`rounded-xl shadow-lg overflow-hidden backdrop-blur-md`}
    style={{...style, gridColumn, gridRow, ...bgStyle}}
    onClick={onClick}
  >
    {overlayImage && overlayImage !== '' && (
      <img
        src={overlayImage}
        alt="overlay"
        className="absolute inset-0 w-full h-full object-contain pointer-events-none z-10"
        style={{ mixBlendMode: 'normal', ...overlayImageStyle }}
      />
    )}
    {statusBar && (
      <div style={{ position: 'relative', zIndex: 15 }}>
        {statusBar}
      </div>
    )}
    {children}
    </div>
)

export default HomeScreenCard 
